module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-content/sales-modal-loading-state.png"